import { GutXAxisOrgan } from '@repo/types';
import c from 'classnames';
import { Spinfinity } from '../Spinfinity';
import Dot from './Dot';
import styles from './GutXAxisBody.module.css';
import Organ from './Organ';
import { useGutXAxisImages } from './hooks';

type GutXAxisBodyProps = {
  organs: GutXAxisOrgan[];
  /** `kit.age_at_sampling`, in days. */
  age: number;
  pregnant: boolean;
  sex: string;
  /** Omit to render a static body, as the PDF report does. */
  onOrganSelect?: (organ: GutXAxisOrgan) => void;
  /** PDF renders eagerly: paged.js would capture whichever frame it caught. */
  waitForImages?: boolean;
  /** Lands on the container. `OrganBadge` uses it to crop this stack. */
  className?: string;
};

export function GutXAxisBody({
  organs,
  age,
  pregnant,
  sex,
  onOrganSelect,
  waitForImages,
  className,
}: GutXAxisBodyProps) {
  const { body, bodyAgeGroup, systems, imgProps, ready } = useGutXAxisImages({
    organs,
    age,
    pregnant,
    sex,
    waitForImages,
  });

  return (
    <div className={c(styles.container, className, !ready && styles.pending)}>
      <img
        src={body}
        className={styles.bodySilhouette}
        {...imgProps('bodySilhouette')}
      />
      {systems.map(({ organ, parts }) => (
        <div key={organ.id} className={styles.system}>
          {parts.map(({ part, src }) => (
            <Organ
              key={part}
              className={c(styles.organ, styles[part], styles[bodyAgeGroup])}
              label={organ.display_name}
              onSelect={onOrganSelect ? () => onOrganSelect(organ) : undefined}
            >
              <img src={src} className={styles.organImage} {...imgProps(part)} />
              <Dot
                displayName={organ.display_name}
                flagLevel={organ.flag_level}
              />
            </Organ>
          ))}
        </div>
      ))}
      {!ready && (
        <span className={styles.loader}>
          <Spinfinity />
        </span>
      )}
    </div>
  );
}
